import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-account-deactivation-alert",
  templateUrl: "./account-deactivation.component.html",
})
export class AccountDeactivationAlertComponent implements OnInit {
  public show: boolean;
  public deactivatesAt: string;

  constructor(private accountService: AccountService) {}

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.account.deactivates_at != null;
      this.deactivatesAt = props.account.deactivates_at;
    });
  }
}
